// extracted by mini-css-extract-plugin
export default {"ErrorPage":"ErrorBoundary_ErrorPage__FCg0w","ErrorMessageContainer":"ErrorBoundary_ErrorMessageContainer__WdCx9"};